<template>
  <v-container fluid fill-height>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-center">
        <div class="text-center mb-5">
          <v-icon class="display-4" color="grey">mdi-calendar-month</v-icon>
        </div>
        <div class="headline font-weight-light">
          No data to report on for this time period. Pick out different dates below.
        </div>
      </v-flex>
      <v-flex
        xs12
        md6
        offset-md3
        class="text-center"
      >
        <the-date-picker
          v-if="initialDates.length >= 2"
          :initialDates="initialDates"
          :pickerOptions="pickerOptions"
          @setDate="setReportingDates"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import TheDatePicker from '../../helpers/TheDatePicker'
  export default {
    components: {TheDatePicker},
    props: {
      initialDates: {
        type: Array,
        default: () => []
      },
      pickerOptions: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      setReportingDates (dates) {
        this.$emit('setDate', dates)
      }
    }
  }
</script>
